import $ from "jquery";

/*GOOGLE MAP*/
function new_map($el) {

  // var
  var $markers = $el.find('.marker');


  // vars
  var args = {
    zoom: 16,
    center: new google.maps.LatLng(0, 0),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
  };

  // create map
  var map = new google.maps.Map($el[0], args);

  // add a markers reference
  map.markers = [];

  // add markers
  $markers.each(function () {

    add_marker($(this), map);

  });

  // center map
  center_map(map);

  // return
  return map;

}

//This function will add a marker to the selected Google Map
function add_marker($marker, map) {
  var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
  var marker = new google.maps.Marker({
    position: latlng,
    map: map,
    icon: $('.acf-map').data('marker-image'),
  });
  map.markers.push(marker);
  if ($marker.html()) {
    var infowindow = new google.maps.InfoWindow({
      content: $marker.html(),
    });
    google.maps.event.addListener(marker, 'click', function () {
      infowindow.open(map, marker);
    });

    // open marker on load
    //google.maps.event.trigger(marker,'click');
  }
}

// center_map
function center_map(map) {

  // vars
  var bounds = new google.maps.LatLngBounds();

  // loop through all markers and create bounds
  $.each(map.markers, function (i, marker) {

    var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

    bounds.extend(latlng);

  });

  // only 1 marker?
  if (map.markers.length === 1) {
    // set center of map
    map.setCenter(bounds.getCenter());
    map.setZoom(13);
  } else {
    // fit to bounds
    map.fitBounds(bounds);
  }

}

//document ready
// global var

// eslint-disable-next-line no-unused-vars
var map = null;

$(document).ready(function () {

  $('.acf-map').each(function () {

    // create map
    map = new_map($(this));

  });

});
